import React, { useContext, useEffect, useState } from "react";
import { Button, message, Modal, Radio, Select, Space, Table } from "antd";
import { connect } from "react-redux";
import moment from "moment";
import * as XLSX from "xlsx-js-style";
import { professionalAction } from "../../_actions";
import { wantedNotificationAction } from "../../_actions/wantedNotification.action";
import { ViewFormModel } from "../ProfessionalForm/ViewForm/ViewFormModel";
import { LanguageContext } from "../../context/LanguageContext";

const READ_BY_OPTIONS = [
  "अलर्ट उशीरा मिळाला, भविष्यात नोटिफिकेशन पाठवावे",
  "CMIS मुळे आरोपी मिळून आला",
  "आरोपी मिळून आला आहे",
];

const CLOSE_READ_BY_OPTIONS = [
  "CMIS मुळे आरोपी मिळून आला",
  "आरोपी मिळून आला आहे",
];

const formatWantedDate = (value) => {
  if (!value) return "";
  const text = String(value).slice(0, 10);
  const parts = text.split("-");
  if (parts.length === 3) {
    return parts[2] + "/" + parts[1] + "/" + parts[0];
  }
  return text;
};

const WantedNotification = (props) => {
  const user = props.user || JSON.parse(localStorage.getItem("user"));
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [criminalViewModel, setCriminalViewModel] = useState(false);
  const [conditionFilter, setConditionFilter] = useState();
  const [typeInfo, setTypeInfo] = useState(null);
  const [readByMap, setReadByMap] = useState({});
  const [savingId, setSavingId] = useState(null);
  const [readByRecord, setReadByRecord] = useState(null);
  const [readByChoice, setReadByChoice] = useState(null);
  const { language, setLanguage, t } = useContext(LanguageContext);

  useEffect(() => {
    props.dispatch(professionalAction.getAllMaster());
    props.dispatch(professionalAction.getCrimeType());
    props.dispatch(professionalAction.getCrimeTitle());
    
    if (!user || (user.role !== "2" && user.role !== "4")) {
      setData([]);
      return;
    }
    setLoading(true);
    wantedNotificationAction
      .getWantedNotificationList({
        role: user.role,
        cityId: user.cityId,
        districtId: user.districtId,
      })
      .then((res) => {
        const list = res && res.data ? res.data : [];
        const selectedMap = {};
        list.forEach((item) => {
          if (item.read_by) selectedMap[item.id] = item.read_by;
        });
        setData(list);
        setReadByMap(selectedMap);
        setLoading(false);
      })
      .catch(() => {
        setData([]);
        setLoading(false);
      });
  }, []);

  const typeLabel = (value) =>
    value === "arrest" ? "अटक" : value === "notice" ? "नोटीस" : value || "-";

  const getCityName = (id) => {
    const cities = props.professionals && props.professionals.pc_cities;
    if (!cities || !cities.length) return "";
    const match = cities.filter((item) => item.id === id)[0];
    return match ? match.City : "";
  };

  const downloadExcel = () => {
    const report_name = "Wanted_Notification";
    const file_name = `${report_name}_${moment().format("DDMMMYYYY")}`;
    const ReportTitle = "wanted notification";
    const list = filteredData();
    const arrData = (list || []).map((item, index) => ({
      "Sr.No": index + 1,
      "CMIS ID": item.masterid || "-",
      नाव: item.name || "-",
      "पो. स्टे": item.districtName || "-",
      स्थिती: item.current_condition || "-",
      दिनांक: formatWantedDate(item.current_condition_date) || "-",
      प्रकार: typeLabel(item.type),
    }));

    if (!arrData.length) return;

    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };
    const subTitleStyle = {
      font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };
    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };
    const cellStyle = {
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet([]);
    const merges = [];
    const headers = Object.keys(arrData[0]);
    const totalCols = headers.length;
    const cityName = getCityName(user && user.cityId);
    const headerData = cityName || "wanted notification";

    XLSX.utils.sheet_add_aoa(ws, [[headerData]], { origin: "A1" });
    ws["A1"].s = titleStyle;
    merges.push({ s: { r: 0, c: 0 }, e: { r: 0, c: totalCols - 1 } });

    XLSX.utils.sheet_add_aoa(ws, [[ReportTitle]], { origin: "A2" });
    ws["A2"].s = subTitleStyle;
    merges.push({ s: { r: 1, c: 0 }, e: { r: 1, c: totalCols - 1 } });

    XLSX.utils.sheet_add_aoa(ws, [headers], { origin: "A3" });
    headers.forEach((_, c) => {
      const cell = XLSX.utils.encode_cell({ r: 2, c });
      if (ws[cell]) ws[cell].s = headerStyle;
    });

    const ws_data = arrData.map((row) => Object.values(row));
    XLSX.utils.sheet_add_aoa(ws, ws_data, { origin: "A4" });
    ws_data.forEach((row, r) => {
      row.forEach((_, c) => {
        const cell = XLSX.utils.encode_cell({ r: r + 3, c });
        if (ws[cell]) ws[cell].s = cellStyle;
      });
    });

    const footerRowIndex = ws_data.length + 6;
    const footerContent = `Generated At ${moment().format(
      "DD MMM YYYY",
    )} From Criminal Monitoring Intelligent System`;
    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });
    ws[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 11, color: { rgb: "555555" } },
      alignment: { horizontal: "center" },
    };
    merges.push({
      s: { r: footerRowIndex - 1, c: 0 },
      e: { r: footerRowIndex - 1, c: totalCols - 1 },
    });

    ws["!cols"] = headers.map((key) => ({
      wch:
        Math.max(
          key.length,
          ...arrData.map((row) => String(row[key] || "").length),
        ) + 6,
    }));
    ws["!rows"] = [{ hpt: 38 }, { hpt: 30 }, { hpt: 42 }];
    for (let i = 3; i < ws_data.length + 3; i++) {
      ws["!rows"][i] = { hpt: 44 };
    }
    ws["!rows"][footerRowIndex - 1] = { hpt: 28 };
    ws["!freeze"] = { ySplit: 3 };
    ws["!merges"] = merges;

    XLSX.utils.book_append_sheet(wb, ws, "Report");
    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };

  const filteredData = () => {
    if (!conditionFilter) return data;
    return (data || []).filter(
      (item) => item.current_condition === conditionFilter,
    );
  };

  const typeDateText = (record) => {
    if (!record) return "";
    if (record.type === "notice") {
      return formatWantedDate(record.notice_date) || "-";
    }
    return formatWantedDate(record.arrest_dateTime) || "-";
  };

  const closeCriminalViewModel = () => {
    setCriminalViewModel(false);
  };

  const onViewAccusedForm = (id) => {
    if (id) {
      props.dispatch(professionalAction.getCriminalsViewsByIdView(id));
      setCriminalViewModel(true);
    }
  };

  const openReadByPopup = (record) => {
    setReadByRecord(record);
    setReadByChoice(readByMap[record.id] || null);
  };

  const closeReadByPopup = () => {
    if (savingId) return;
    setReadByRecord(null);
    setReadByChoice(null);
  };

  const onReadBySelect = () => {
    if (!readByRecord || !readByChoice) return;
    const record = readByRecord;
    const option = readByChoice;
    setSavingId(record.id);
    wantedNotificationAction
      .updateWantedNotificationReadBy({
        id: record.id,
        read_by: option,
      })
      .then((res) => {
        if (!res || !res.success) {
          message.error("अपडेट अयशस्वी");
          return;
        }
        const isClose = CLOSE_READ_BY_OPTIONS.indexOf(option) !== -1;
        setReadByMap((prev) => ({
          ...prev,
          [record.id]: option,
        }));
        setData((prev) =>
          (prev || []).map((item) => {
            if (item.id !== record.id) return item;
            if (!isClose) {
              return { ...item, read_by: option, is_close: false };
            }
            return {
              ...item,
              read_by: option,
              is_close: true,
              current_condition: null,
              current_condition_date: null,
            };
          }),
        );
        setReadByRecord(null);
        setReadByChoice(null);
      })
      .catch(() => {
        message.error("अपडेट अयशस्वी");
      })
      .finally(() => {
        setSavingId(null);
      });
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 16,
        }}
      >
        <h2 style={{ margin: 0 }}>Wanted Notification</h2>
        <Space>
          <Select
            allowClear
            placeholder="पाहिजे / फरार"
            style={{ width: 180 }}
            value={conditionFilter}
            onChange={(value) => setConditionFilter(value)}
          >
            <Select.Option value="पाहिजे">पाहिजे</Select.Option>
            <Select.Option value="फरार">फरार</Select.Option>
          </Select>
          <Button type="primary" onClick={downloadExcel}>
            Download Excel
          </Button>
        </Space>
      </div>
      <Table
        rowKey="id"
        loading={loading}
        dataSource={filteredData()}
        pagination={{ pageSize: 10 }}
        locale={{ emptyText: "डेटा उपलब्ध नाही" }}
        columns={[
          {
            title: t("police_station_required"),
            key: "policeSideNeed",
            onHeaderCell: () => ({
              style: {
                backgroundColor: "#ffcc80",
                color: "#000",
                fontWeight: "bold",
              },
            }),
            onCell: () => ({
              style: {
                backgroundColor: "#ffcc80",
                color: "#000",
              },
            }),
            render: (text, record) => (
              <Space size="middle" style={{ maxWidth: 300 }}>
                {record.policeSideNeed}
              </Space>
            ),
          },
          {
            title: t("accused_name"),
            dataIndex: "name",
            key: "name",
          },
          {
            title: t("current_status"),
            dataIndex: "current_condition",
            key: "current_condition",
            render: (value, record) => (
              <Space direction="vertical" size={2} style={{ maxWidth: 300 }}>
                <span>{value || "N/A"}</span>
                <span>
                  {record.current_condition_date
                    ? moment(record.current_condition_date).format("DD-MM-YYYY")
                    : "N/A"}
                </span>
              </Space>
            ),
          },

          {
            title: "प्रकार",
            dataIndex: "type",
            key: "type",
            render: (value, record) => {
              const isNotice = record.type === "notice";

              const date = isNotice
                ? record.notice_date
                : record.arrest_dateTime;

              const policeStation = isNotice
                ? record.notice_police_station
                : record.arrest_police_station;

              return (
                <Space direction="vertical" size={2}>
                  <span style={{ color: "#1677ff", fontWeight: 500 }}>
                    {isNotice ? "Notice" : "Arrest"}
                  </span>
                  <span>
                    {date ? moment(date).format("DD-MM-YYYY") : "-"}
                    {" / "}
                    {policeStation || "-"}
                  </span>
                </Space>
              );
            },
          },
          {
            title: "View",
            key: "view",
            render: (_, record) => (
              <Button
                type="primary"
                onClick={() => onViewAccusedForm(record.masterid)}
              >
                View
              </Button>
            ),
          },
          {
            title: "Action",
            key: "readBy",
            render: (_, record) => {
              const selected = readByMap[record.id];
              return (
                <Space direction="vertical" size={4}>
                  <Button
                    loading={savingId === record.id}
                    onClick={() => openReadByPopup(record)}
                  >
                    Read By
                  </Button>
                  {selected ? <span>{selected}</span> : null}
                </Space>
              );
            },
          },
        ]}
      />
      <Modal
        title="Read By"
        visible={!!readByRecord}
        onCancel={closeReadByPopup}
        onOk={onReadBySelect}
        okText="Save"
        cancelText="Cancel"
        confirmLoading={!!savingId}
        okButtonProps={{ disabled: !readByChoice }}
        centered
      >
        <Radio.Group
          value={readByChoice}
          onChange={(event) => setReadByChoice(event.target.value)}
        >
          <Space direction="vertical">
            {READ_BY_OPTIONS.map((option) => (
              <Radio key={option} value={option}>
                {option}
              </Radio>
            ))}
          </Space>
        </Radio.Group>
      </Modal>
      <Modal
        title={typeInfo ? typeLabel(typeInfo.type) : ""}
        visible={!!typeInfo}
        onCancel={() => setTypeInfo(null)}
        footer={null}
        centered
      >
        <p style={{ fontSize: 16, marginBottom: 0 }}>
          {typeInfo && typeInfo.type === "notice"
            ? "नोटीस दिनांक"
            : "अटक दिनांक"}
          {" : "}
          <strong>{typeDateText(typeInfo)}</strong>
        </p>
      </Modal>
      <Modal
        title="आरोपी प्रोफाइल"
        top
        visible={criminalViewModel}
        onOk={closeCriminalViewModel}
        onCancel={closeCriminalViewModel}
        width={95 + "%"}
      >
        <ViewFormModel
          key={props.user && props.user.id}
          dataStates={props.professionals}
        ></ViewFormModel>
      </Modal>
    </div>
  );
};

function mapStateToProps(state) {
  const { authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    professionals,
  };
}

const connectedWantedNotification =
  connect(mapStateToProps)(WantedNotification);
export { connectedWantedNotification as WantedNotificationList };
